var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 268,
    viewBox: "0 0 352 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.2857,
    height: 268,
    fill: "#3098F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2852,
    width: 51.2914,
    height: 268,
    fill: "#082C4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.576,
    width: 50.2857,
    height: 268,
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.863 0H203.155V268H151.863V0Z",
    fill: "#FE6571"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 203.152,
    width: 29.1657,
    height: 268,
    fill: "#F2EAE2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 232.32,
    width: 30.1714,
    height: 268,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 262.492,
    width: 30.1714,
    height: 268,
    fill: "#D9D9DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 292.664,
    width: 29.1657,
    height: 268,
    fill: "#747481"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 321.828,
    width: 30.1714,
    height: 268,
    fill: "#05051E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorDesktop);
export default __webpack_public_path__ + "static/media/color-desktop.7bef0f4cf8937d1ad51425fa8e6caa53.svg";
export { ForwardRef as ReactComponent };